import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// const homeName = process.env.VUE_APP_HOME_NAME
const VUE_APP_EVENT = JSON.parse(process.env.VUE_APP_EVENT)
const VUE_APP_TABLE = JSON.parse(process.env.VUE_APP_TABLE)
const VUE_APP_POINT_EXCHANGE = JSON.parse(process.env.VUE_APP_POINT_EXCHANGE)
const VUE_APP_DEV = JSON.parse(process.env.VUE_APP_DEV)
const VUE_APP_PROJECT = JSON.parse(process.env.VUE_APP_PROJECT)
const Questionnaire = JSON.parse(process.env.VUE_APP_Questionnaire)
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/dinning/:id',
  //   name: 'dinning',
  //   meta: {
  //     title: 'LoginPage',
  //     requiresAuth: false,
  //     role: ['admin', 'manager', 'employee', 'user']
  //   },
  //   component: () => import('../views/dinning')
  // },
  {
    path: '/login',
    name: 'LoginPage',
    async beforeEnter (to, from, next) {
      await store.dispatch('checkLogin')
      if (store.state.isLoggedIn) {
        next({ name: 'Home' })
      } else {
        next()
      }
    },
    meta: {
      title: 'LoginPage',
      requiresAuth: false,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import('../views/LoginPage')
  },
  {
    path: '/signup/:code',
    name: 'signupPage',
    meta: {
      title: 'signupPage',
      requiresAuth: false,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import('../views/signup.vue')
  },
  {
    path: '/',
    name: 'LoggedIn',
    meta: {
      title: '',
      requiresAuth: false,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import('../views/LoggedIn'),
    children: [
      ...require('./kpi.js'),
      {
        path: '/permissionDenied',
        name: 'permissionDenied',
        meta: {
          title: 'permissionDenied',
          requiresAuth: false
        },
        component: () => import('../views/permissionDenied')
      },
      {
        path: '/Home',
        name: 'Home',
        query: { page: '營運服務' },
        meta: {
          title: '首頁',
          requiresAuth: true,
          iconType: 'image',
          iconSize: { width: '65px', height: '65px' },
          icon: '/img/icons/android-chrome-192x192.png',
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: Home
      },
      {
        path: '/PersonalSetting',
        name: 'PersonalSetting',
        meta: {
          title: '個人設定',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/PersonalSetting.vue')
      },
      // {
      //   path: '/PushInformation',
      //   name: 'PushInformation',
      //   meta: {
      //     label_en: 'Push Information',
      //     color: 'var(--color-home-7)',
      //     icon: 'iconPush',
      //     icon1: 'push.svg',
      //     appCube: true,
      //     production: true,
      //     title: '公告推播',
      //     group: 3,
      //     requiresAuth: true,
      //     manager: null,
      //     employee: null,
      //     note: null,
      //     role: ['admin', 'manager', 'employee']
      //   },
      //   component: () => import('../views/PushInformation.vue')
      // },
      // {
      //   path: '/PushInformationP',
      //   name: 'PushInformationP',
      //   meta: {
      //     label_en: 'Push Information to some one',
      //     color: 'var(--color-home-7)',
      //     icon: 'iconDirectPush',
      //     icon1: 'push.svg',
      //     appCube: true,
      //     production: true,
      //     title: '指定推播',
      //     group: 3,
      //     requiresAuth: true,
      //     manager: null,
      //     employee: null,
      //     role: ['admin', 'manager', 'employee'],
      //     note: null,
      //     disabled: false
      //     // note: 'COMMING SOON',
      //     // disabled: true
      //   },
      //   component: () => import('../views/PushInformation2.vue')
      // },
      {
        path: '/recordsearch',
        name: 'recordsearch',
        meta: {
          label_en: 'Member Records',
          color: 'var(--color-home-7)',
          icon: 'iconUsed',
          icon1: 'svg/menu/couponRecord.svg',
          appCube: true,
          production: true,
          title: '會員使用紀錄查詢',
          category: '會員專區',
          group: 2,
          requiresAuth: true,
          manager: null,
          employee: null,
          role: ['admin', 'manager', 'employee'],
          note: null,
          disabled: false
          // note: 'COMMING SOON',
          // disabled: true
        },
        component: () => import('../views/ticketRecord/recordsearch.vue')
      },
      {
        path: '/couponRecord',
        name: 'couponRecord',
        meta: {
          label_en: 'Coupon Records',
          color: 'var(--color-home-7)',
          icon: 'iconUsed',
          icon1: 'svg/menu/couponRecord.svg',
          appCube: true,
          production: true,
          title: '兌換使用紀錄',
          category: '會員專區',
          group: 2,
          requiresAuth: true,
          manager: null,
          employee: null,
          role: ['admin', 'manager', 'employee'],
          note: null,
          disabled: false
          // note: 'COMMING SOON',
          // disabled: true
        },
        component: () => import('../views/ticketRecord/couponRecord.vue')
      },
      {
        path: '/storeCardRecord',
        name: 'storeCardRecord',
        meta: {
          label_en: 'Storecard Records',
          color: 'var(--color-home-7)',
          icon: 'iconUsed',
          icon1: 'svg/menu/couponRecord.svg',
          appCube: true,
          production: true,
          title: '點數紀錄查詢',
          category: '會員專區',
          group: 2,
          requiresAuth: true,
          manager: null,
          employee: null,
          role: ['admin', 'manager', 'employee'],
          note: null,
          disabled: false
          // note: 'COMMING SOON',
          // disabled: true
        },
        component: () => import('../views/storecard/index.vue')
      },
      {
        path: '/PushInformationv2',
        name: 'push',
        query: { page: '新增推播' },
        meta: {
          label_en: 'Push Information v2',
          color: 'var(--color-home-7)',
          icon: 'iconPush',
          icon1: 'push.svg',
          appCube: true,
          production: true,
          title: '公告推播',
          category: '會員專區',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/push/index.vue')
      },
      {
        path: '/CouponSchedule',
        name: 'CouponSchedule',
        meta: {
          label_en: 'Coupon Schedule',
          color: 'var(--color-home-7)',
          icon: 'iconTicket',
          icon1: 'ticket.svg',
          appCube: true,
          production: true,
          title: '預約排程票券',
          category: '會員專區',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/CouponSchedule.vue')
      },
      {
        path: '/CouponScheduleList',
        name: 'CouponScheduleList',
        meta: {
          label_en: 'Coupon List',
          color: 'var(--color-home-7)',
          icon: 'iconTicket',
          icon1: 'ticket.svg',
          appCube: true,
          production: true,
          title: '優惠票券',
          category: '會員專區',
          image: '/cube/coupon.png',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/CouponScheduleList/index.vue')
      },
      VUE_APP_POINT_EXCHANGE ? {
        path: '/pointExange',
        name: 'pointExange',
        meta: {
          label_en: 'Point Exchange',
          color: 'var(--color-home-7)',
          icon: 'iconTicket',
          icon1: 'point.svg',
          appCube: VUE_APP_POINT_EXCHANGE,
          production: VUE_APP_POINT_EXCHANGE,
          category: '會員專區',
          title: '點數兌換',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/pointExange/index.vue')
      } : null,
      {
        path: '/PresentCouponList',
        name: 'PresentCouponList',
        meta: {
          label_en: 'Coupon List on Signup',
          color: 'var(--color-home-7)',
          icon: 'iconGift',
          icon1: 'gift.svg',
          appCube: true,
          production: true,
          title: '優惠贈品',
          category: '會員專區',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/PresentCouponList.vue')
      },
      {
        path: '/ticketRecord',
        name: 'ticketRecord',
        meta: {
          label_en: 'Ticket Records',
          color: 'var(--color-home-7)',
          icon: 'iconUsed',
          icon1: 'svg/menu/couponRecord.svg',
          appCube: true,
          production: true,
          title: '入園紀錄',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          role: ['admin', 'manager', 'employee'],
          note: null,
          disabled: false
          // note: 'COMMING SOON',
          // disabled: true
        },
        component: () => import('../views/ticketRecord/index.vue')
      },
      {
        path: '/visit',
        name: 'visit',
        meta: {
          label_en: 'Visit Booking List',
          color: 'var(--color-rest)',
          icon: 'iconRest',
          icon1: 'team.svg',
          group: 1,
          appCube: true,
          production: true,
          category: '營運服務',
          title: '團體預約',
          image: '/cube/visit.png',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/visitbooking/index.vue')
      },
      {
        path: '/babyFirstBirthday',
        name: 'babyFirstBirthday',
        meta: {
          label_en: 'Baby First Birthday',
          icon: 'iconBaby',
          icon1: 'baby.svg',
          color: '#D88993',
          group: 1,
          appCube: true,
          category: '營運服務',
          production: true,
          title: '周晬禮讚',
          image: '/cube/babys.png',
          requiresAuth: true,
          manager: null,
          employee: null,
          // note: 'COMMING SOON',
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/baby/FirstBirthday.vue')
      },
      {
        path: '/babyCelender',
        name: 'babyCelender',
        meta: {
          label_en: 'Baby First Birthday Celender',
          color: '#D88993',
          icon: 'iconCelender',
          icon1: 'calendar.svg',
          group: 1,
          appCube: true,
          category: '營運服務',
          production: true,
          title: '周晬禮讚月曆',
          requiresAuth: true,
          manager: null,
          employee: null,
          // note: 'COMMING SOON',
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/baby/Celender.vue')
      },
      {
        path: '/eventsBooking',
        name: 'eventsBooking',
        meta: {
          label_en: 'Events Booking',
          color: '#517FA4',
          icon: 'iconEvent',
          icon1: 'event.svg',
          group: 1,
          appCube: VUE_APP_EVENT,
          category: '營運服務',
          production: VUE_APP_EVENT,
          title: '活動預約',
          image: '/cube/events.png',
          requiresAuth: true,
          manager: null,
          employee: null,
          // note: 'COMMING SOON',
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/event/eventsBooking.vue')
      },
      {
        path: '/event/:id/list',
        name: 'event',
        meta: {
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/partial/editEvent.vue')
      },
      {
        path: '/events',
        name: 'events',
        meta: {
          label_en: 'Events Setting',
          color: '#517FA4',
          icon: 'iconSetting',
          icon1: 'event.svg',
          group: 1,
          appCube: VUE_APP_EVENT,
          category: '營運服務',
          production: VUE_APP_EVENT,
          title: '活動列表/設定',
          requiresAuth: true,
          manager: null,
          employee: null,
          // note: 'COMMING SOON',
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/events.vue'),
        children: []
      },
      {
        path: '/eventsCelender',
        name: 'eventsCelender',
        meta: {
          label_en: 'Events Celender',
          color: '#517FA4',
          icon: 'iconGroup',
          icon1: 'calendar.svg',
          group: 1,
          appCube: VUE_APP_EVENT,
          category: '營運服務',
          production: VUE_APP_EVENT,
          title: '活動月曆',
          requiresAuth: true,
          manager: null,
          employee: null,
          // note: 'COMMING SOON',
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/event/Calendar.vue'),
        children: []
      },
      // ==================== 松柏軒 =================================
      {
        path: '/restaurantViewH',
        name: 'restaurantViewH',
        query: { page: '松柏軒' },
        meta: {
          label_en: 'Pre-Order List',
          color: '#C78550',
          icon: 'iconRest',
          icon1: 'calendar.svg',
          group: 2,
          appCube: true,
          production: true,
          title: '松柏軒預約資訊',
          category: '營運服務',
          image: '/cube/booking.png',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/restaurantView/index.vue')
      },
      {
        path: '/restaurantTablesv2H',
        name: 'restaurantTablesv2H',
        query: { page: '松柏軒' },
        meta: {
          label_en: 'Restaurant Seating Plan',
          color: '#C78550',
          icon: 'iconTable',
          icon1: 'table.svg',
          group: 2,
          appCube: VUE_APP_TABLE,
          category: '營運服務',
          production: VUE_APP_TABLE,
          title: '松柏軒桌次表',
          image: '/cube/seating.png',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/restaurant/Tables.vue')
      },
      // {
      //   path: '/restaurantTablesv2ArrangementH',
      //   name: 'restaurantTablesv2ArrangementH',
      //   query: { page: '松柏軒' },
      //   meta: {
      //     label_en: 'Restaurant Seating Arrangement',
      //     color: '#C78550',
      //     icon: 'iconTable',
      //     icon1: 'table.svg',
      //     group: 2,
      //     appCube: VUE_APP_TABLE,
      //     category: '營運服務',
      //     production: VUE_APP_TABLE,
      //     title: '松柏軒餐點安排表',
      //     image: '/cube/seating.png',
      //     requiresAuth: true,
      //     manager: null,
      //     employee: null,
      //     note: null,
      //     role: ['admin', 'manager', 'employee']
      //   },
      //   component: () => import('../views/restaurant/TablesDish.vue')
      // },
      {
        path: '/restCelenderH',
        name: 'restCelenderH',
        query: { page: '松柏軒' },
        meta: {
          label_en: 'Calendar',
          color: '#C78550',
          icon: 'iconCelender',
          icon1: 'calendar.svg',
          group: 2,
          appCube: true,
          category: '營運服務',
          production: true,
          title: '松柏軒月曆',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/restaurant/calendar.vue')
      },
      {
        path: '/restaurantViewHTemp',
        name: 'restaurantViewHTemp',
        query: { page: VUE_APP_DEV ? '松柏軒年菜' : '美饌輕鬆GO' },
        meta: {
          label_en: 'Pre-Order List',
          color: '#C78550',
          icon: 'iconRest',
          icon1: 'calendar.svg',
          group: 2,
          appCube: true,
          production: true,
          title: '美饌輕鬆GO預訂資訊',
          category: '營運服務',
          image: '/cube/newYear.jpg',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/restaurantView/index.vue')
      },
      {
        path: '/restCelenderTemp',
        name: 'restCelenderTemp',
        query: { page: VUE_APP_DEV ? '松柏軒年菜' : '美饌輕鬆GO' },
        meta: {
          label_en: 'Calendar',
          color: '#C78550',
          icon: 'iconCelender',
          icon1: 'calendar.svg',
          group: 2,
          appCube: true,
          category: '營運服務',
          production: true,
          title: '美饌輕鬆GO月曆',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/restaurant/calendar.vue')
      },
      // {
      //   path: '/weddingPrepare',
      //   name: 'weddingPrepare',
      //   query: { page: '松柏軒' },
      //   meta: {
      //     label_en: 'Pre-Order List',
      //     color: '#C78550',
      //     icon: 'iconRest',
      //     icon1: 'wedding2.svg',
      //     group: 2,
      //     appCube: false,
      //     production: false,
      //     title: '婚禮企劃',
      //     category: '營運服務',
      //     image: '/cube/wedding2.png',
      //     position: 'center -10px',
      //     size: '276px 120px',
      //     requiresAuth: true,
      //     manager: null,
      //     employee: null,
      //     note: null,
      //     role: ['admin', 'manager', 'employee']
      //   },
      //   component: () => import('../views/restaurantView/wedding.vue')
      // },
      // ==================== 松緣會館 =================================
      {
        path: '/restaurantView',
        name: 'restaurantView',
        query: { page: '松緣會館' },
        meta: {
          label_en: 'Pre-Order List',
          color: '#9687B5',
          icon: 'iconRest',
          icon1: 'calendar.svg',
          group: 3,
          appCube: true,
          production: true,
          title: '松緣會館預約資訊',
          category: '營運服務',
          image: '/cube/bookingH.jpg',
          requiresAuth: true,
          manager: null,
          position: 'center -25px',
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/restaurantView/index.vue')
      },
      {
        path: '/restaurantTablesv2',
        name: 'restaurantTablesv2',
        query: { page: '松緣會館' },
        meta: {
          label_en: 'Restaurant Seating Plan',
          color: '#9687B5',
          icon: 'iconTable',
          icon1: 'table.svg',
          group: 3,
          appCube: VUE_APP_TABLE,
          category: '營運服務',
          production: VUE_APP_TABLE,
          title: '松緣會館桌次表',
          image: '/cube/seatingH.png',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/restaurant/Tables.vue')
      },
      // {
      //   path: '/restaurantTablesv2Arrangement',
      //   name: 'restaurantTablesv2Arrangement',
      //   query: { page: '松緣會館' },
      //   meta: {
      //     label_en: 'Restaurant Seating Arrangement',
      //     color: '#9687B5',
      //     icon: 'iconTable',
      //     icon1: 'table.svg',
      //     group: 3,
      //     appCube: VUE_APP_TABLE,
      //     category: '營運服務',
      //     production: VUE_APP_TABLE,
      //     title: '松緣會館餐點安排表',
      //     image: '/cube/seatingH.png',
      //     requiresAuth: true,
      //     manager: null,
      //     employee: null,
      //     note: null,
      //     role: ['admin', 'manager', 'employee']
      //   },
      //   component: () => import('../views/restaurant/TablesDish.vue')
      // },
      {
        path: '/restCelender',
        name: 'restCelender',
        query: { page: '松緣會館' },
        meta: {
          label_en: 'Calendar',
          color: '#9687B5',
          icon: 'iconCelender',
          icon1: 'calendar.svg',
          group: 3,
          appCube: true,
          category: '營運服務',
          production: true,
          title: '松緣會館月曆',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/restaurant/calendar.vue')
      },
      ...(VUE_APP_PROJECT ? [
        {
          path: '/restProject',
          name: 'restProject',
          meta: {
            label_en: 'Project',
            color: '#f7914f',
            icon: 'iconCelender',
            icon1: 'svg/menu/partner.svg',
            group: 3,
            appCube: true,
            category: '營運服務',
            production: true,
            title: '合作專案',
            requiresAuth: true,
            manager: null,
            employee: null,
            note: null,
            role: ['admin', 'manager', 'employee']
          },
          component: () => import('../views/project/index.vue')
        },
        {
          path: '/partner',
          name: 'partner',
          meta: {
            label_en: 'Project Partner',
            color: '#f7914f',
            icon: 'iconCelender',
            icon1: 'svg/menu/partner.svg',
            group: 3,
            appCube: true,
            category: '營運服務',
            production: true,
            title: '合作代理',
            requiresAuth: true,
            manager: null,
            employee: null,
            note: null,
            role: ['admin', 'manager', 'employee']
          },
          component: () => import('../views/Company/partner.vue')
        },
        {
          path: '/restProject/:id',
          name: 'restProjectSingle',
          meta: {
            role: ['admin', 'manager', 'employee'],
            icon1: 'svg/menu/partner.svg'
          },
          component: () => import('../views/project/each.vue')
        }
      ] : []),
      {
        path: '/wedding',
        name: 'wedding',
        meta: {
          label_en: 'Wedding Booking',
          color: '#AC807A',
          icon: 'iconRest',
          icon1: 'wedding.svg',
          group: 4,
          appCube: true,
          production: true,
          title: '甜蜜佳緣',
          category: '營運服務',
          image: '/cube/wedding.png',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/wedding/index.vue')
      },
      {
        path: '/weddingCelender',
        name: 'weddingCelender',
        meta: {
          label_en: 'Wedding Calendar',
          color: '#AC807A',
          icon: 'iconCelender',
          icon1: 'calendar.svg',
          group: 4,
          appCube: true,
          category: '營運服務',
          production: true,
          title: '甜蜜佳緣月曆',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/wedding/calendar.vue')
      },
      {
        path: '/maps',
        name: 'Maps',
        meta: {
          label_en: 'Maps Editor',
          color: '#7A8661',
          icon: 'iconSetting',
          icon1: 'setting.svg',
          appCube: true,
          category: '營運服務',
          production: true,
          image: '/cube/map.png',
          title: '地圖導覽',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          // note: 'COMMING SOON',
          note: null,
          role: ['admin', 'manager', 'employee'],
          disabled: false
        },
        component: () => import('../views/map/Maps.vue')
      },
      {
        path: '/mapsediter/:id?',
        name: 'MapsEditor',
        meta: {
          label_en: 'Maps Editor',
          color: '#7A8661',
          icon: 'iconSetting',
          appCube: true,
          category: '營運服務',
          production: true,
          title: '地圖導覽(編輯)',
          image: '/cube/map.png',
          // group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          note: 'COMMING SOON',
          role: ['admin', 'manager', 'employee'],
          disabled: true
        },
        component: () => import('../views/map/MapsEditor.vue')
      },
      {
        path: '/mapsSummary',
        name: 'mapsSummary',
        meta: {
          label_en: 'Maps Summary',
          color: '#7A8661',
          icon: 'iconSetting',
          icon1: 'pi.svg',
          appCube: true,
          category: '營運服務',
          production: true,
          title: '地圖導覽統計',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          // note: 'COMMING SOON',
          note: null,
          role: ['admin', 'manager', 'employee'],
          disabled: false
        },
        component: () => import('../views/map/MapsSummary.vue')
      },
      {
        path: '/couponRecord',
        name: 'couponRecord',
        meta: {
          label_en: 'Coupon Records',
          color: '#68A89C',
          icon: 'iconUsed',
          icon1: 'svg/menu/couponRecord.svg',
          appCube: true,
          category: '營運服務',
          production: true,
          title: '兌換使用紀錄',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          role: ['admin', 'manager', 'employee'],
          note: null,
          disabled: false
          // note: 'COMMING SOON',
          // disabled: true
        },
        component: () => import('../views/couponRecord.vue')
      },
      {
        path: '/VIPInformation',
        name: 'VIPInformation',
        meta: {
          label_en: 'VIP Information',
          color: 'var(--color-home-4)',
          icon1: 'svg/menu/user.svg',
          icon: 'iconMember',
          group: 3,
          appCube: true,
          production: true,
          category: '會員專區',
          title: '會員資訊',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/users/members/index.vue')
      },
      {
        path: '/tags',
        name: 'tags',
        query: { selected: true, page: '新增推播' },
        meta: {
          label_en: 'Tags of VIP Member',
          color: 'var(--color-home-4)',
          icon: 'iconDirectPush',
          icon1: 'push.svg',
          appCube: true,
          production: true,
          category: '會員專區',
          title: '會員群組',
          group: 3,
          requiresAuth: true,
          manager: null,
          employee: null,
          role: ['admin', 'manager', 'employee'],
          note: null,
          disabled: false
          // note: 'COMMING SOON',
          // disabled: true
        },
        component: () => import('../views/users/tags/index.vue')
      },
      {
        path: '/LeaderInformation',
        name: 'LeaderInformation',
        query: { role: 'leader' },
        meta: {
          label_en: 'Leader Information',
          color: '#BD4B4B',
          icon1: 'svg/menu/agency.svg',
          icon: 'iconMember',
          iconSize: '30px',
          group: 3,
          appCube: true,
          production: true,
          title: '領隊資訊',
          category: '會員專區',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/users/members/leader.vue')
      },
      {
        path: '/AgencyInformation',
        name: 'AgencyInformation',
        query: { role: 'agency' },
        meta: {
          label_en: 'Agency Information',
          color: '#BD4B4B',
          icon1: 'svg/menu/agency.svg',
          icon: 'iconMember',
          iconSize: '30px',
          group: 3,
          appCube: true,
          production: true,
          title: '代理商窗口',
          category: '會員專區',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/users/members/agency.vue')
      },
      {
        path: '/GeneralAgency',
        name: 'GeneralAgency',
        query: { type: 'General' },
        meta: {
          label_en: 'General Agency',
          color: 'var(--color-home-2)',
          icon1: 'svg/menu/company.svg',
          icon: 'iconMember',
          group: 3,
          appCube: true,
          production: true,
          title: '一般代理商',
          category: '會員專區',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/Company/index.vue')
      },
      {
        path: '/SpecialAgency',
        name: 'SpecialAgency',
        query: { type: 'Special' },
        meta: {
          label_en: 'Special Agency',
          color: 'var(--color-home-2)',
          icon1: 'svg/menu/company.svg',
          icon: 'iconMember',
          group: 3,
          appCube: true,
          production: true,
          title: '特約代理商',
          category: '會員專區',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/Company/special.vue')
      },
      {
        path: '/EmployeeSetting',
        name: 'EmployeeSetting',
        meta: {
          label_en: 'Staff Information',
          color: '#CCA16E',
          icon: 'iconToolBox',
          icon1: 'staff.svg',
          group: 5,
          appCube: true,
          production: true,
          title: '員工資訊',
          category: '會員專區',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/Employee/index.vue')
      },
      {
        path: '/PTSetting',
        name: 'PTSetting',
        meta: {
          label_en: 'PT Information',
          color: '#CCA16E',
          icon: 'iconToolBox',
          group: 5,
          appCube: true,
          production: true,
          title: 'PT資訊',
          category: '會員專區',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/PTSetting.vue')
      },
      {
        path: '/PTSetting',
        name: 'PTSetting',
        meta: {
          label_en: 'PT Information',
          color: '#CCA16E',
          icon: 'iconToolBox',
          group: 5,
          appCube: true,
          production: true,
          title: '導覽人員',
          category: '會員專區',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: 'COMMING SOON',
          role: ['admin', 'manager', 'employee'],
          disabled: true
        },
        component: () => import('../views/PTSetting.vue')
      },
      // {
      //   path: '/restaurantWorker',
      //   name: 'restaurantWorker',
      //   meta: {
      //     label_en: 'Restaurant Summary',
      //     color: '#BD4B4B',
      //     icon: 'iconChart',
      //     group: 5,
      //     appCube: true,
      //     production: true,
      //     title: '服務KPI',
      //     requiresAuth: true,
      //     manager: ['營運一部'],
      //     employee: [],
      //     note: null,
      //     role: ['admin', 'manager']
      //   },
      //   component: () => import('../views/restaurantWorker.vue')
      // },
      ...require('./setting'),
      {
        path: '/restaurantSet',
        name: 'restaurantSet',
        query: { page: '商品列表' },
        meta: {
          label_en: 'Dish Setting',
          color: 'var(--color-home-6)',
          icon: 'iconSetting',
          icon1: 'setting.svg',
          group: 5,
          appCube: true,
          production: true,
          title: '商品設定',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/restaurant/dish.vue')
      },
      {
        path: '/restaurantAttendance',
        name: 'restaurantAttendance',
        meta: {
          label_en: 'restaurant Attendance',
          color: 'var(--color-home-4)',
          icon: 'iconSetting',
          icon1: 'setting.svg',
          group: 3,
          appCube: true,
          production: true,
          title: '出勤紀錄',
          requiresAuth: true,
          manager: null,
          employee: null,
          note: null,
          role: ['admin', 'manager', 'employee']
        },
        component: () => import('../views/clockinout/index.vue')
      },
      {
        path: '/questionnaire',
        name: 'questionnaire',
        meta: {
          label_en: 'Questionnaire',
          color: '#C89A9A',
          icon: 'iconUsed',
          icon1: 'svg/menu/questionnaire.svg',
          appCube: Questionnaire,
          production: Questionnaire,
          title: '問券表單',
          category: '會員專區',
          group: 4,
          requiresAuth: true,
          manager: null,
          employee: null,
          role: ['admin', 'manager', 'employee'],
          // note: null,
          // disabled: false,
          note: 'COMMING SOON',
          disabled: true
        },
        component: () => import('../views/questionnaire/index.vue')
      },
      {
        path: '/questionnairenew',
        name: 'questionnairenew',
        meta: {
          label_en: 'Questionnaire',
          color: '#C89A9A',
          icon: 'iconUsed',
          icon1: 'svg/menu/questionnaire.svg',
          appCube: false,
          production: Questionnaire,
          title: '問券表單-新增',
          group: 5,
          requiresAuth: true,
          manager: null,
          employee: null,
          role: ['admin', 'manager', 'employee'],
          note: null,
          disabled: false
          // note: 'COMMING SOON',
          // disabled: true
        },
        component: () => import('../views/questionnaire/new.vue')
      },
      {
        path: '/questionnaireedit',
        name: 'questionnaireedit',
        meta: {
          label_en: 'Questionnaire',
          color: '#C89A9A',
          icon: 'iconUsed',
          icon1: 'svg/menu/questionnaire.svg',
          appCube: false,
          production: Questionnaire,
          title: '問券表單-編輯',
          group: 5,
          requiresAuth: true,
          manager: null,
          employee: null,
          role: ['admin', 'manager', 'employee'],
          note: null,
          disabled: false
          // note: 'COMMING SOON',
          // disabled: true
        },
        component: () => import('../views/questionnaire/edit.vue')
      }
    ].filter(e => e).map(e => {
      e.meta.role = ['admin', 'manager', 'employee']
      e.meta.employee = null
      e.meta.admin = null
      return e
    })
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
